module.exports = __webpack_public_path__ + "public/img/elcmz.48b07b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/elcmz.png
// module id = 6Izs
// module chunks = 1